// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d98370a0","453":"3f05e339","596":"e9c4374e","977":"5cc227b4"}[chunkId] + ".chunk.js";
};